export interface Idocumento {
  documentoID: number;
  propietarioID: string;
  descripcion: string;
  FotoRuta: string;
  status: boolean;
  userName: string;
  userCreation: string;
  dateCreation: string;
  userLastUpdate: string;
  dateLastUpdate: string;
  claseArchivo: string;
}

export class Documento implements Idocumento {
  constructor(
    public documentoID: number,
    public propietarioID: string,
    public descripcion: string,
    public FotoRuta: string,
    public status: boolean,
    public userName: string,
    public userCreation: string,
    public dateCreation: string,
    public userLastUpdate: string,
    public dateLastUpdate: string,
    public claseArchivo: string,
  ) {
    this.documentoID = documentoID;
    this.propietarioID = propietarioID;
    this.descripcion = descripcion;
    this.FotoRuta = FotoRuta;
    this.status = status;
    this.userName = userName;
    this.userCreation = userCreation;
    this.dateCreation = dateCreation;
    this.userLastUpdate = userLastUpdate;
    this.dateLastUpdate = dateLastUpdate;
    this.claseArchivo = claseArchivo;
  }
}
